import { useCallback } from 'react';
import { useTRPCAPI, useTRPCQuery } from '../../trpc/trpc';

/** What the accept page shows before the invitee joins (`team.invitePreview`). */
export function useTeamInvitePreview(token: string) {
  const trpcAPI = useTRPCAPI();
  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch: refetchUnsafe,
  } = useTRPCQuery(trpcAPI.team.invitePreview.queryOptions({ token }, { retry: false }));
  const refetch = useCallback(() => {
    refetchUnsafe().catch(console.error);
  }, [refetchUnsafe]);
  return { data, isLoading, isFetching, error, refetch };
}
